import classNames from 'classnames';
import { WebP } from './WebP';

export function SelectLabel({ webp, png, text, imageClassName, labelClassName }) {
  return (
    <div className="flex items-center">
      <WebP webp={webp} fallback={png} imageClassName={classNames('w-5 h-auto', imageClassName)} />
      <span className={classNames('text-md font-normal ml-4', labelClassName)}>{text}</span>
    </div>
  );
}
